<script>
import DatePicker from "./DatePicker";
import {toMomentDateFormat} from "@/common/format";
import moment_timezone from "moment-timezone";
import {enumDef} from "@/common/enumDefs";

export default {
    mixins: [DatePicker],
    props: {
        type: { type: String, default: "datetime" },
        dateFormat: { type: String, default: "L HH:mm" },
        valueFormat: { type: String, default: "yyyy-MM-dd HH:mm:ssZZ" },
        onlyFutureDates: { type: Boolean, default: true },
        defaultTimeForFutureDays: { type: String, default: "13:00" }
    },
    methods: {
        adjustDate(date) {
          let cetDate = moment_timezone.tz(date, "Europe/Berlin").format();
        	let asReturnValue = function(moment) {
            return moment.format(toMomentDateFormat(this.valueFormat));
			    }.bind(this)

			    // Just return date as is, if it is not defined
          if (!cetDate) {
            return cetDate;
          }

          // in case we have a range of dates do no adjustments for now
          if (cetDate instanceof Array) {
            return cetDate;
          }

	        let adjustedDate = moment(cetDate);
	        if (this.skipWeekends && [6, 7].includes(adjustedDate.isoWeekday())) {
            adjustedDate = adjustedDate.add(1, 'w').isoWeekday(1); // Move date to next monday
          }

          let datePart = adjustedDate.format("YYYY-MM-DD");
          let timePart = adjustedDate.format("HH:mm");
          let daysDifference = moment(datePart).diff(moment_timezone().tz("Europe/Berlin").format("YYYY-MM-DD"), "d");

          // We do not adjust past dates
          if (daysDifference < 0) {
              return asReturnValue(adjustedDate);
          }

          // If today is selected then we adjust the time to be at least later than the required adjustment
          if (daysDifference === 0) {
              let difference = adjustedDate.diff(moment_timezone().tz("Europe/Berlin"), enumDef.nowAdjustment.unit);
              if (difference < enumDef.nowAdjustment.value) {
                  return asReturnValue(moment_timezone().tz("Europe/Berlin").add(enumDef.nowAdjustment.value, enumDef.nowAdjustment.unit));
              } else {
                  return asReturnValue(adjustedDate);
              }
          }

          // For future days if no time was explicitly set we use the default time configures
          if (daysDifference > 0) {
              if (timePart === "00:00") {
                  return asReturnValue(moment_timezone(datePart + " " + this.defaultTimeForFutureDays));
              } else {
                  return asReturnValue(adjustedDate);
              }
          }
        }
    },
};
</script>